import { render, staticRenderFns } from "./MatchFieldsSelect.vue?vue&type=template&id=6e70de87&"
import script from "./MatchFieldsSelect.vue?vue&type=script&lang=ts&"
export * from "./MatchFieldsSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports